import React, { useContext } from "react";
import { ServiceRequestContext } from "context/ServiceRequestContext";
import { INPUT_TYPES, PHONEMASK } from "utils/CommonConstants";
import TextInput from "sub_components/Common/BloxTextInput";
import styled from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
const phoneValidations = [
  { message: "Phone Number must be 10 digits", pattern: /^[0-9]{10}$/ },
];
const emailValidations = [
  { message: "Required field", pattern: /.+/ },
  {
    message: "Please enter a valid email address.",
    pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  },
];

const ContactDetailStyle = styled.div`
  height: 160px;
  .blox-text-input {
    width: 100%;
    margin-bottom: 8px;
    margin-top: 10px;
  }
  .attendee-selection {
    height: 220px;
  }
  .ScrollbarsCustom-Track {
    right: -20px !important;
    top: 10px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.support} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }

  .attendees-wrapper {
    display: flex;
    height: 70px;
    flex-direction: column;
    .attendee {
      margin-top: 5px;
    }
  }

  .button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 220px;
    .blox-text-input {
      margin-bottom: 20px;
    }
    .attendees-wrapper {
      display: flex;
      height: 100px;
      flex-direction: column;
      .attendee {
        margin-top: 5px;
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 390px;
    .blox-text-input {
      margin-bottom: 50px;
    }
    .attendees-wrapper {
      display: flex;
      height: 150px;
      flex-direction: column;
      .attendee {
        margin-top: 5px;
      }
    }
  }
`;

export const ContactDetailScreen = () => {
  const { inputs, change } = useContext(ServiceRequestContext);
  const attendees = inputs?.attendees;
  const ila = inputs?.type === "ila" ? true : false;
  const type = inputs?.type;

  function onAttendeeChange() {
    const updatedArray = [...attendees, inputs?.guest];
    change({ target: { name: "attendees", value: updatedArray } });
    change({ target: { name: "guest", value: "" } });
  }

  return (
    <ContactDetailStyle>
      <ScrollView>
        <TextInput
          placeholder=""
          type={INPUT_TYPES.INPUT}
          label={
            type === "remote-hands"
              ? "What’s the contact’s name?"
              : "What's your guests name?"
          }
          name="name"
          value={inputs.name}
          validations={[{ message: "Required field", pattern: /.+/ }]}
          onChange={change}
          active={true}
          hideCheckmark
          cypressId="ga-guest-name"
        />

        <TextInput
          placeholder=""
          active={true}
          type={INPUT_TYPES.INPUT}
          label="What's their email?"
          name="email"
          hideCheckmark
          value={inputs?.email}
          validations={emailValidations}
          onChange={change}
          cypressId="ga-email"
        />

        <TextInput
          placeholder=""
          active={true}
          type={INPUT_TYPES.INPUT}
          hideCheckmark
          label="What's their phone number?"
          name="phone"
          value={inputs?.phone}
          onChange={change}
          mask={PHONEMASK}
          validations={phoneValidations}
          cypressId="ga-phone"
        />
        {ila && (
          <div className="attendee-selection">
            <TextInput
              placeholder=""
              type={INPUT_TYPES.INPUT}
              label="Do you have any additional attendees?"
              name="guest"
              value={inputs?.guest}
              validations={[{ message: "Required field", pattern: /.+/ }]}
              onChange={change}
              active={true}
              hideCheckmark
              cypressId="ga-guest-name"
            />
            <div className="button-wrapper">
              <BloxButton
                className="buttons41"
                id="okay"
                text="ADD"
                module="support"
                enabled={true}
                onClick={onAttendeeChange}
                cypressId="add-attendee"
              />
            </div>
            <div className="attendees-wrapper body10">
              <ScrollView>
                <div className=" body10">
                  {attendees &&
                    attendees?.length !== 0 &&
                    attendees.map((attendee) => (
                      <div className="attendee">{attendee} </div>
                    ))}
                </div>
              </ScrollView>
            </div>
          </div>
        )}
      </ScrollView>
    </ContactDetailStyle>
  );
};
